@switch (columnName) {
  @default {
    {{ element[columnName] ?? '---' }}
  }
  @case ('expiryType') {
    @if (element.expiryType === 'IntervalExpiry' || element.expiryType === 'Both') {
      <mat-icon matTooltip="{{ 'intervalExpiry' | translate }}">schedule</mat-icon>
    }
    @if (element.expiryType === 'RuntimeExpiry' || element.expiryType === 'Both') {
      <mat-icon matTooltip="{{ 'runtimeExpiry' | translate }}">event_repeat</mat-icon>
    }
    @if (element.expiryType === 'OneTimeExpiry') {
      <mat-icon matTooltip="{{ 'oneTimeExpiry' | translate }}">looks_one</mat-icon>
    }
    @if (!element.expiryType) {
      ---
    }
  }
  @case ('responsible') {
    @for (position of element.responsibleForPositions; track position) {
      <div>
        {{ position?.name }}
      </div>
    }
    @for (positionGroup of element.responsibleForPositionGroups; track positionGroup) {
      <div>
        {{ positionGroup?.name }}
      </div>
    }
    @for (role of element.responsibleForRoles; track role) {
      <div>
        {{ role?.name }}
      </div>
    }
  }
  @case ('locationTooltip') {
    <app-text-overflow-label [text]="element?.menu?.path"></app-text-overflow-label>
  }
  @case ('location') {
    {{ element?.menu?.path }}
  }
  @case ('critical') {
    @if (element.isCriticalComponent) {
      <mat-icon matTooltip="{{ 'jobBelongsToCriticalComponent' | translate }}">warning</mat-icon>
    }
  }
  @case ('edit') {
    <button mat-button (click)="buttonFunctions.edit()">
      <mat-icon>edit</mat-icon>
    </button>
  }
  @case ('delete') {
    <button mat-button (click)="buttonFunctions.delete()">
      <mat-icon>delete</mat-icon>
    </button>
  }
  @case ('quantity') {
    {{ element?.quantity }} {{ element?.quantityType?.name }}
  }
  @case ('usedQuantity') {
    {{ element?.usedQuantity }} {{ element?.quantityType?.name }}
  }
  @case ('quantityType') {
    {{ element?.quantityType?.name }}
  }
  @case ('dueDateRuntime') {
    @if (element.expiryType === 'OneTimeExpiry') {
      {{ element?.dueDateOrRuntime?.oneTimeExpiry | date }}
    } @else {
      {{ element?.dueDateOrRuntime?.intervalExpiry | date }}
      @if (element?.dueDateOrRuntime?.runtimeExpiry?.hours) {
        | {{ element?.dueDateOrRuntime?.runtimeExpiry?.hours }} h
      }
    }
    @if (element.expiryType === 'OneTimeExpiry') {
      {{ element?.expiry?.oneTimeExpiry.dueDate | date }}
    }
  }
  @case ('interval') {
    @if (element.expiryType === 'IntervalExpiry' || element.expiryType === 'Both') {
      {{ element?.interval?.intervalExpiry }}d
    }
    @if (element.expiryType === 'Both') {
      /
    }
    @if (element.expiryType === 'RuntimeExpiry' || element.expiryType === 'Both') {
      {{ element?.interval?.runtimeExpiry }}h
    }
    @if (!element.expiryType || element.expiryType === 'OneTimeExpiry') {
      ---
    }
  }
  @case ('timeUntilExpiry') {
    @if (element.expiryType === 'IntervalExpiry' || element.expiryType === 'Both') {
      {{ element?.timeUntilExpiry?.intervalExpiry | number: '1.0-0' }}d
    }
    @if (element.expiryType === 'Both') {
      or
    }
    @if (element.expiryType === 'RuntimeExpiry' || element.expiryType === 'Both') {
      {{ element?.timeUntilExpiry?.runtimeExpiry.timeUntilExpiry }}h at
      {{ element?.timeUntilExpiry?.runtimeExpiry.avgDailyRuntime }}h/d
    }
    @if (element.expiryType === 'OneTimeExpiry') {
      {{ element?.timeUntilExpiry?.intervalExpiry | number: '1.0-0' }}d
    }
    @if (!element.expiryType) {
      ---
    }
  }
  @case ('status') {
    <app-ui-pill [name]="element[columnName]"></app-ui-pill>
  }
  @case ('actions') {
    <app-ui-button
      buttonType="secondary"
      text="{{ (element.isDraft ? 'openDraft' : 'perform') | translate }}"
      [routerLink]="performRoute"
      privilege="MAINTENANCE-JOB_PERFORM"
      [disabled]="performButtonDisabled"
      [tooltip]="performButtonTooltip | translate"
    ></app-ui-button>
  }
  @case ('access') {
    <app-positions-cell [element]="element"></app-positions-cell>
  }
  @case ('project') {
    <app-text-overflow-label [text]="element.project?.name ?? '---'"></app-text-overflow-label>
  }
  @case ('restore') {
    <app-ui-button
      appConfirmDialog
      confirmTitle="restore"
      confirmMessage="youAreRestoring"
      [confirmEntityName]="element.name"
      (confirmed)="restore()"
      buttonType="secondary"
      text="{{ 'restore' | translate }}"
      appStopClickPropagation
      [privilege]="Privileges.MaintenanceJobRestore"
    ></app-ui-button>
  }
  @case ('reactivate') {
    <app-ui-button
      appConfirmDialog
      appStopClickPropagation
      confirmTitle="reactivate"
      confirmButtonText="reactivate"
      [confirmEntityName]="element['name']"
      confirmMessage="youAreReactivating"
      [showAreYouSure]="true"
      (confirmed)="reactivate()"
      text="{{ 'reactivate' | translate }}"
      buttonType="secondary"
      privilege="MAINTENANCE-JOB_ENABLE"
    ></app-ui-button>
  }
}
